import { render, staticRenderFns } from "./CardapioCD.vue?vue&type=template&id=2bb4329f&scoped=true&"
import script from "./CardapioCD.vue?vue&type=script&lang=js&"
export * from "./CardapioCD.vue?vue&type=script&lang=js&"
import style0 from "./CardapioCD.vue?vue&type=style&index=0&id=2bb4329f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4329f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCheckbox,VIcon,VSpacer})
